import type { ReadonlyRecord } from '../../utils'

import configurablesJson from './configurables.json'
import type {
    ConfigurationMetadata,
    ConfigurationMetadataSchema,
    ConfigurationMetadataSupportedExample,
    ConfigurationMetadataSupportedTypes,
} from './ConfigurationMetadata'
import { config } from './default'
import type { ConnectwareAdminWebAppConfig } from './WebAppConfig'

const configurables: ReadonlyRecord<string, ConfigurationMetadata> = configurablesJson

export {
    type ConnectwareAdminWebAppConfig,
    type ConfigurationMetadata,
    type ConfigurationMetadataSupportedTypes,
    type ConfigurationMetadataSchema,
    type ConfigurationMetadataSupportedExample,
    config as defaultConfiguration,
    configurables,
}
